// extracted by mini-css-extract-plugin
module.exports = {"comp":"Screen6_comp__wvlsX"};